import { useColorScheme as useColorSchemeBase } from 'react-native';
import { ThemeMode as ThemeModeApp } from '@annunciate/core';
import { useThemeOrDefault } from './useThemeOrDefault';
export const useColorScheme = () => {
    const system = useColorSchemeBase();
    const theme = useThemeOrDefault();
    if (theme === ThemeModeApp.LIGHT) {
        return 'light';
    }
    else if (theme === ThemeModeApp.SYSTEM) {
        if (system) {
            return system;
        }
        else {
            return 'light';
        }
    }
    else {
        return 'dark';
    }
};
//# sourceMappingURL=useColorScheme.js.map